import { Component, Input } from '@angular/core';

@Component({
    selector: 'activity-row-assignment',
    template: `
    <div style="float: left; margin-right: 10px;">
      <mat-icon>person</mat-icon>
    </div>
    <div>
      <div class="description">
        <span ng-bind-html="activity.activityHtml"></span>
        <strong>New Assignment</strong>
        <div class="text">
          {{ getInitiator() }} {{ getAssignmentLabel() }} {{ activity.borrowerName }}
          from {{ activity.meta['oldLender'] }} to {{ activity.meta['newLender'] }}.
          <span *ngIf="activity.assignmentType == 'offCadence'"><strong>Reason:</strong> Off cadence</span>
        </div>
      </div>
    </div>
    `
})
export class ActivityRowAssignmentComponent {
    @Input() activity;
    activityIcon = 'icon-20-bank';

    getAssignmentLabel() {
      return this.activity.subType === 'bulk' ? 'bulk assigned' : 'assigned';
    }

    getInitiator() {
      if (this.activity.meta['initiatorLender']
        && this.activity.meta['initiatorId'] !== this.activity.meta['oldLenderUser']) {
          return this.activity.meta['initiatorLender'];
      } else {
        return this.activity.meta['oldLender'];
      }
    }
}
